Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _airbnbPropTypes = require('airbnb-prop-types');

var _adjustableSpacing = require('../constants/adjustableSpacing');

var _adjustableSpacing2 = _interopRequireDefault(_adjustableSpacing);

var _withStyles = require('../themes/withStyles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var propTypes = (0, _airbnbPropTypes.forbidExtraProps)(Object.assign({}, _withStyles.withStylesPropTypes, {
  children: _propTypes2['default'].string.isRequired,
  paragraphSpacing: _adjustableSpacing.adjustableSpacingShape
}));

var defaultProps = {
  paragraphSpacing: _adjustableSpacing2['default'].SMALL
};

function insertLineBreaks(str) {
  return str.split('\n').reduce(function (result, line) {
    result.push(_react2['default'].createElement('br', { key: line }), line);

    return result;
  }, []).slice(1);
}

function LineBreaks(_ref) {
  var children = _ref.children,
      css = _ref.css,
      paragraphSpacing = _ref.paragraphSpacing,
      styles = _ref.styles,
      theme = _ref.theme;

  // ignore > 2 consecutive newline characters
  var str = children.trim().replace(/\n\n+/g, '\n\n');
  var paragraphs = str.split('\n\n');

  if (paragraphs.length > 1) {
    var margin = { marginTop: paragraphSpacing * theme.unit };

    return _react2['default'].createElement(
      'div',
      null,
      paragraphs.map(function (paragraph, index) {
        return _react2['default'].createElement(
          'p',
          _extends({
            key: paragraph
          }, css(styles.paragraph, index === 0 && styles.paragraph_first, index > 0 && margin)),
          insertLineBreaks(paragraph)
        );
      })
    );
  }

  return _react2['default'].createElement(
    'p',
    css(styles.paragraph, styles.paragraph_first),
    insertLineBreaks(str)
  );
}

LineBreaks.componentCategory = 'Core';
LineBreaks.displayName = 'LineBreaks';
LineBreaks.propTypes = propTypes;
LineBreaks.defaultProps = defaultProps;

exports['default'] = (0, _withStyles.withStyles)(function () {
  return {
    paragraph: {
      marginBottom: 0
    },

    paragraph_first: {
      marginTop: 0
    }
  };
})(LineBreaks);


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/exp/LineBreaks.js
// module id = 412
// module chunks = 168707334958949